module.exports = __webpack_public_path__ + "img/subscribeInPakage.8cb7d636.svg";